<form [formGroup]="form" class="w100 flex-around-center">
  <mat-form-field style="width: calc(100% - 150px)">
    @if (title) {
      <mat-label>{{title}}</mat-label>
    }
    <textarea matInput formControlName="currentValue" (keyup.enter)="addValue()">
    </textarea>
  </mat-form-field>
  <button mat-flat-button matSuffix (click)="$event.stopPropagation();addValue()" color="primary">
    <mat-icon>playlist_add</mat-icon>
  </button>
  <button matBadge="{{numberElements$|async}}" matBadgeColor="primary"
    [disabled]="(numberElements$|async)==0"
    mat-flat-button color="primary" (click)="showLine()">
    <mat-icon>reorder</mat-icon>
  </button>
</form>
